import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { ImagePreview } from "features/EstimateRequest/components/ImagePreview";
import { type ReactNode, useMemo } from "react";

export function FileImagePreview({
  file,
  fileName,
  width = 200,
  height = 100,
  error,
  placeholderText,
  PlaceholderSlot,
}: {
  file?: File | null;
  fileName?: string;
  width?: number;
  height?: number;
  error?: boolean;
  placeholderText?: string;
  PlaceholderSlot?: ReactNode;
}) {
  const dataUrl = useMemo(() => {
    if (file) {
      return URL.createObjectURL(file);
    }
    return null;
  }, [file]);
  if (!dataUrl) {
    return (
      <Paper
        data-testid="image-preview_placeholder"
        variant="outlined"
        sx={{
          width,
          height,
          overflow: "hidden",
          backgroundColor: "transparent",
          display: "flex",
          alignItems: "center",
          border: (theme) =>
            error ? `1px solid ${theme.palette.error.main}` : undefined,
        }}
      >
        {placeholderText ? (
          <Typography
            flex={1}
            textAlign="center"
            color={error ? "error.main" : "text.secondary"}
          >
            {placeholderText}
          </Typography>
        ) : (
          PlaceholderSlot
        )}
      </Paper>
    );
  }
  return (
    <ImagePreview
      src={dataUrl}
      alt={fileName ?? file?.name ?? ""}
      width={width}
      height={height}
    />
  );
}
